import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-manage-bi-organisations',
  templateUrl: './manage-bi-organisations.component.html',
  styleUrls: ['./manage-bi-organisations.component.scss'],
})
export class ManageBiOrganisationsComponent {}
